import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import Navbar from '../Components/Navbar';
import Footer from '../Components/Footer';
import social from '../Assets/social.png';
import brand from '../Assets/Vector.png';
import icon from '../Assets/fixed-width.png';
import icon2 from '../Assets/fixed-width2.png';
import icon3 from '../Assets/fixed-width3.png';
import icon4 from '../Assets/fixed-width4.png';
import row from '../Assets/marq (1).png';
import row2 from '../Assets/marq (2).png';
import row3 from '../Assets/marq (3).png';
import row4 from '../Assets/marq (4).png';
import row5 from '../Assets/marq (5).png';
import SignupPopup from '../Components/SignupPopup';

function Home() {
  const [showSignup, setShowSignup] = useState(false); // State to control signup popup visibility
  const [workshops, setWorkshops] = useState([]); // State to hold the workshop data

  useEffect(() => {
    const fetchWorkshops = async () => {
      try {
        const response = await axios.get('https://onexinfinity-backend.vercel.app/api/workshop');
        setWorkshops(response.data.data);
      } catch (error) {
        console.error('Error fetching workshops:', error);
        alert('Failed to fetch workshops. Please try again later.');
      }
    };

    fetchWorkshops();
  }, []);
  return (
    <>
      <Navbar />
      <SignupPopup isOpen={showSignup} onClose={() => setShowSignup(false)} />
      <div className='banner'>
        <h2 data-aos="fade-right">Lowkey... This Might<br/>
          Change Everything</h2>
        <br/>
        <button 
          data-aos="zoom-in" 
          onClick={() => setShowSignup(true)}
          style={{
            padding: '12px 30px',
            fontSize: '16px',
            fontWeight: '600',
            color: '#fff',
            backgroundColor: '#6e8efb',
            border: 'none',
            borderRadius: '30px',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            boxShadow: '0 4px 15px rgba(110, 142, 251, 0.3)'
          }}
          onMouseOver={(e) => {
            e.target.style.transform = 'translateY(-2px)';
            e.target.style.boxShadow = '0 6px 20px rgba(110, 142, 251, 0.4)';
          }}
          onMouseOut={(e) => {
            e.target.style.transform = 'translateY(0)';
            e.target.style.boxShadow = '0 4px 15px rgba(110, 142, 251, 0.3)';
          }}
        >
          Get Started
        </button>
    </div>
    <div className='ourpartner'>
    
    <h3 data-aos="fade-right">Our <span>Partners</span></h3>
    <br/>
    <br/>

    <img src={brand}/>

    </div>
    <div className='about-divss'>

    <div className='about-div'>
   <div className='about-div-heading'>
  
    <h3 data-aos="zoom-in" >About <span>OneXinfinity</span></h3>
    <p data-aos="zoom-in">we understand the challenges and complexities that businesses face in today's dynamic marketplace. That's why we offer a comprehensive suite of consulting services.
    Founded on the principles of innovation, integrity, and excellence, we are a team of  seasoned professionals.
    Founded on the principles of innovation, integrity, and excellence, we are a team of  seasoned professionals.</p>

   </div>
   <br/>
   <br/>
   <br/>
   <br/>
   <div className='entrepreneur-div'>
    <div className='entrepreneur'>
    <img src={icon}/>
    <br/>
    <br/>
    <h3>Entrepreneur</h3>
    <p>The gradual accumulation of <br/>
information about atomic and  <br/>
small-scale behaviour...</p>

    </div>
    <div className='entrepreneur'>
    <img src={icon2}/>
    <br/>
    <br/>
    <h3>Content Creator</h3>
    <p>The gradual accumulation of <br/>
information about atomic and  <br/>
small-scale behaviour...</p>

    </div>
    <div className='entrepreneur'>
    <img src={icon3}/>
    <br/>
    <br/>
    <h3>Author</h3>
    <p>The gradual accumulation of <br/>
information about atomic and  <br/>
small-scale behaviour...</p>

    </div>
    <div className='entrepreneur'>
    <img src={icon4}/>
    <br/>
    <br/>
    <h3>Investor</h3>
    <p>The gradual accumulation of <br/>
information about atomic and  <br/>
small-scale behaviour...</p>

    </div>
   </div>

    </div>

    </div>

    <div className='Find'>
      <div className='Find-left'>
        <h4 data-aos="fade-right">
          Find <a 
            href="https://www.instagram.com/nikhillranjann?igsh=MTFkb21uc3kxdmxnaQ%3D%3D&utm_source=qr" 
            target="_blank" 
            rel="noopener noreferrer" 
            style={{color: '#23a6f0', textDecoration: 'none'}}>
            Nikhil
          </a>
        </h4>
        <br/>
        <br/>
        <h3 data-aos="fade-right">
          OneXinfinity has a strong community of many followers across all popular social media.
        </h3>
      </div>
      <div className='Find-right'>
        <img data-aos="zoom-in" src={social} alt="Social Media" />
      </div>
    </div>

    <div className='services-section'>
      <h2 data-aos="zoom-in">Work <span>With Us</span></h2>
      <div className='services-grid'>
        <div className='service-card' data-aos="fade-up">
          <h3>Courses</h3>
          <p>Comprehensive learning programs designed to help you master new skills in blockchain, technology, and business development.</p>
          <Link to="/courses" className='learn-more'>Explore Courses</Link>
        </div>
        <div className='service-card' data-aos="fade-up" data-aos-delay="100">
          <h3>Workshop</h3>
          <p>Interactive sessions and hands-on training to gain practical knowledge and real-world experience from industry experts.</p>
          <Link to="/workshop" className='learn-more'>View Workshops</Link>
        </div>
        <div className='service-card' data-aos="fade-up" data-aos-delay="200">
          <h3>Angel Investing</h3>
          <p>Opportunities to invest in innovative startups and be part of the next generation of successful entrepreneurs.</p>
          <Link to="/angel-investing" className='learn-more'>Learn More</Link>
        </div>
        <div className='service-card' data-aos="fade-up" data-aos-delay="300">
          <h3>Book a Call</h3>
          <p>Schedule a one-on-one consultation to discuss how we can help you achieve your personal or business goals.</p>
          <Link to="/book-call" className='learn-more'>Schedule Now</Link>
        </div>
      </div>
      
      <div className='journal-overview' data-aos="fade-up">
        <div className='journal-content'>
          <h2>Journal</h2>
          <p>Explore my latest thoughts, insights, and experiences on technology, leadership, and personal growth.</p>
          <Link to="/blog" className='view-journal'>View Journal →</Link>
        </div>
      </div>
    </div>
    
    <div className='Workshop-heading'>
      <h2 data-aos="zoom-in">Event <span>& Workshop</span></h2>
    </div>
      <div className='Workshop-cards'>

        {workshops.map((workshop) => (
          <div key={workshop._id} className='Workshop-card'>
            <div className='center'>
              <img src={workshop.image} alt={workshop.title} />
            </div>
            <div className='eventdate'>
            {new Date(workshop.date).toLocaleDateString(undefined, { day: '2-digit', month: 'short' })}
            </div>
            <div className='eventcity'>
            {workshop.location}
            </div>
            <div className='Workshop-text'>
              <h2>{workshop.title}</h2>
              <div style={{padding:'15px'}}>
              <h3 dangerouslySetInnerHTML={{ __html: workshop.description }}></h3>
            
            <div className='speaker'>
              <h5>~ {workshop.speaker}</h5>
              
            </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    <div className='PARTNERS'>
    
    <h3 data-aos="zoom-in">Connect with me for a <span>speaking engagement?</span></h3>
    {/* <div class="marquee">
  <div class="marquee-content">
    <img src={row} alt="Image 1"/>
    <img src={row} alt="Image 2"/>
    <img src={row} alt="Image 3"/>
    <img src={row} alt="Image 4"/>
  </div>
</div> */}
<br/>
<br/>
<marquee>
<div className='marquee'>

<img src={row} alt="Image 1"/>
    <img src={row2} alt="Image 2"/>
    <img src={row3} alt="Image 3"/>
    <img src={row4} alt="Image 4"/>
    <img src={row5} alt="Image 4"/>
    <img src={row} alt="Image 1"/>
    <img src={row2} alt="Image 2"/>
    <img src={row3} alt="Image 3"/>
    <img src={row4} alt="Image 4"/>
    <img src={row5} alt="Image 4"/>
    <img src={row} alt="Image 1"/>
    <img src={row2} alt="Image 2"/>
    <img src={row3} alt="Image 3"/>
    <img src={row4} alt="Image 4"/>
    <img src={row5} alt="Image 4"/>
</div>


</marquee>

    </div>
  <br/>
    <br/>
{/*       <br/>
    <br/>   
    <div className='joinus' >
    <div className='joinus-left' >
    <img src={img}/>
        
        </div>
        <div className='joinus-right'>
       

        <h2 data-aos="fade-right">JOIN <span>US</span></h2>
        
        <h3 data-aos="fade-right">Problems trying to resolve the conflict between <br/>
        the two major realms of Classical physics: Newtonian mechanics </h3>
        <br/>
  
        <div className='newsletter' data-aos="fade-right">
        <input placeholder='Your Email'/>
        <button >Subscribe</button>

        </div>
        </div>
        
    </div>

  
    <br/>
    <br/> */}

    <Footer/>
   </>
  )
}

export default Home
